import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=4c7a12ab&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=4c7a12ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a12ab",
  null
  
)

export default component.exports